
export default function EquipmentListItem() {
    return {
        restrict: 'E',
        template: require('./equipment-list-item.component.html'),
        scope: {
            equipment: '='
        }
    };
}
